import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { COUNTRIES, getCountryName } from "../../constant/countries";
import { addData, deleteData, getAllData } from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import moment from "moment-timezone";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DeleteModel from "../../components/DeleteModel";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const ExchangeRate = () => {
  const [rows, setRows] = useState([]);
  const [tiers, setTiers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [editData, setEditData] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  // detail (view) modal
  const [viewData, setViewData] = useState(null);
  const [showView, setShowView] = useState(false);

  // delete modal
  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // form fields
  const [baseCurrency, setBaseCurrency] = useState("");
  const [targetCurrency, setTargetCurrency] = useState("");
  const [exchangeRate, setExchangeRate] = useState("");
  const [multifactor, setMultifactor] = useState("");
  const [tier, setTier] = useState("");
  const [country, setCountry] = useState("");

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // filter
  const [filterValue, setFilterValue] = useState("");
  const [tierFilter, setTierFilter] = useState("");

  useEffect(() => {
    fetchExchangeRates();
    fetchTiers();
  }, []);

  useEffect(() => {
    setBaseCurrency(editData?.base_currency || "");
    setTargetCurrency(editData?.target_currency || "");
    setExchangeRate(
      editData?.exchange_rate !== undefined && editData?.exchange_rate !== null
        ? editData.exchange_rate
        : ""
    );
    setMultifactor(
      editData?.multifactor !== undefined && editData?.multifactor !== null
        ? editData.multifactor
        : ""
    );
    setTier(editData?.tier || "");
    setCountry(editData?.country || "");
  }, [editData]);

  const fetchExchangeRates = async () => {
    let url = `${endPoints.api.GET_EXCHANGE_RATE}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        // /list returns a raw array; tolerate a wrapped { data } shape too
        const data = Array.isArray(response)
          ? response
          : response?.data || [];
        setRows(data);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const fetchTiers = async () => {
    try {
      const tiersResp = await getAllData(`${endPoints.api.GET_TIERS}`);
      const list = Array.isArray(tiersResp) ? tiersResp : tiersResp?.data || [];
      setTiers(list);
    } catch (error) {
      console.error(error);
    }
  };

  // Multifactor is shared across a tier (managed on the Tier Multifactor screen),
  // so it is derived from the selected tier rather than entered manually here.
  const multifactorForTier = (selectedTier) => {
    const match = rows.find((r) => r.tier === selectedTier);
    return match && match.multifactor !== undefined && match.multifactor !== null
      ? match.multifactor
      : "";
  };

  const handleTierChange = (selectedTier) => {
    setTier(selectedTier);
    setMultifactor(multifactorForTier(selectedTier));
  };

  const handleOk = () => {
    if (baseCurrency && targetCurrency && exchangeRate && multifactor) {
      let url = editData?.id
        ? `${endPoints.api.UPDATE_EXCHANGE_RATE}`
        : `${endPoints.api.ADD_EXCHANGE_RATE}`;

      let payload = {
        base_currency: baseCurrency,
        target_currency: targetCurrency,
        exchange_rate: exchangeRate,
        multifactor: multifactor,
        tier: tier,
        country: country,
      };
      if (editData?.id) {
        payload.id = editData.id;
      }

      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message || "Saved Successfully");
            fetchExchangeRates();
            handleClose();
          } else {
            ErrorToast(response?.data?.message || "Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("All fields are required");
    }
  };

  const handleView = (row) => {
    setViewData(row);
    setShowView(true);
  };

  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deleteExchangeRate = () => {
    const id = rowDataToDelete.id;
    let url = `${endPoints.api.DELETE_EXCHANGE_RATE}${id}`;
    setIsLoading(true);
    deleteData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === 200) {
          setShowDeleteModal(false);
          fetchExchangeRates();
          SuccesToast("Deleted Successfully");
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const handleFilterChange = (event) => {
    setFilterValue(event.target.value.toLowerCase());
    setPage(0);
  };

  const rowsToDisplay = rows
    .filter((item) => (tierFilter ? item?.tier === tierFilter : true))
    .filter((item) =>
      filterValue.length > 0
        ? item?.base_currency?.toLowerCase().includes(filterValue) ||
          item?.target_currency?.toLowerCase().includes(filterValue) ||
          item?.tier?.toLowerCase().includes(filterValue) ||
          item?.country?.toLowerCase().includes(filterValue) ||
          getCountryName(item?.country).toLowerCase().includes(filterValue)
        : true
    );

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - rowsToDisplay.length)
      : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteExchangeRate}
        />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Exchange Rate
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div
                  className="table_search"
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <TextField
                    style={{ marginBottom: "10px", width: "25%" }}
                    placeholder="Search by currency..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Form.Select
                    style={{ marginBottom: "10px", width: "200px" }}
                    value={tierFilter}
                    onChange={(event) => {
                      setTierFilter(event.target.value);
                      setPage(0);
                    }}
                  >
                    <option value="">All Tiers</option>
                    {tiers.map((t) => (
                      <option key={t} value={t}>
                        Tier {t}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">ID</TableCell>
                            <TableCell align="center">Base Currency</TableCell>
                            <TableCell align="center">Target Currency</TableCell>
                            <TableCell align="center">Exchange Rate</TableCell>
                            <TableCell align="center">Multifactor</TableCell>
                            <TableCell align="center">Tier</TableCell>
                            <TableCell align="center">Country</TableCell>
                            <TableCell align="center">Updated At</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">{row.id}</TableCell>
                                <TableCell align="center">
                                  {row.base_currency}
                                </TableCell>
                                <TableCell align="center">
                                  {row.target_currency}
                                </TableCell>
                                <TableCell align="center">
                                  {row.exchange_rate}
                                </TableCell>
                                <TableCell align="center">
                                  {row.multifactor}
                                </TableCell>
                                <TableCell align="center">
                                  {row.tier}
                                </TableCell>
                                <TableCell align="center">
                                  {getCountryName(row.country)}
                                </TableCell>
                                <TableCell align="center">
                                  {row.updated_at
                                    ? moment(row.updated_at).format(
                                        "YYYY-MM-DD HH:mm"
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell align="center">
                                  <VisibilityIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleView(row)}
                                  />
                                  <EditIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setShow(true);
                                      setEditData(row);
                                    }}
                                  />
                                  <DeleteIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDelete(row)}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={9} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={9}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>

                  {/* Add / Edit Modal */}
                  <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                        {editData?.id
                          ? "Edit Exchange Rate"
                          : "Add Exchange Rate"}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="baseCurrency">
                            <Form.Label>Base Currency</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="e.g. USD"
                              value={baseCurrency}
                              onChange={(event) =>
                                setBaseCurrency(event.target.value)
                              }
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group
                            className="mb-3"
                            controlId="targetCurrency"
                          >
                            <Form.Label>Target Currency</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="e.g. EUR"
                              value={targetCurrency}
                              onChange={(event) =>
                                setTargetCurrency(event.target.value)
                              }
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="exchangeRate">
                            <Form.Label>Exchange Rate</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Exchange Rate"
                              value={exchangeRate}
                              onChange={(event) =>
                                setExchangeRate(event.target.value)
                              }
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="multifactor">
                            <Form.Label>Multifactor</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Multifactor"
                              value={multifactor}
                              disabled
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="tier">
                            <Form.Label>Tier</Form.Label>
                            <Form.Select
                              value={tier}
                              onChange={(event) =>
                                handleTierChange(event.target.value)
                              }
                            >
                              <option value="">Select Tier</option>
                              {tiers.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="country">
                            <Form.Label>Country</Form.Label>
                            <Form.Select
                              value={country}
                              onChange={(event) =>
                                setCountry(event.target.value)
                              }
                            >
                              <option value="">Select Country</option>
                              {COUNTRIES.map((item) => (
                                <option key={item.code} value={item.code}>
                                  {item.name}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={handleOk}
                        style={{
                          background: "#04631e",
                          borderColor: "#04631e",
                        }}
                      >
                        Apply
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  {/* Detail (View) Modal */}
                  <Modal
                    show={showView}
                    onHide={() => setShowView(false)}
                    size="lg"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Exchange Rate Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {viewData && (
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <strong>ID:</strong> {viewData.id}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Base Currency:</strong>{" "}
                            {viewData.base_currency}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Target Currency:</strong>{" "}
                            {viewData.target_currency}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Exchange Rate:</strong>{" "}
                            {viewData.exchange_rate}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Multifactor:</strong> {viewData.multifactor}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Tier:</strong> {viewData.tier}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Country:</strong>{" "}
                            {getCountryName(viewData.country)}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Updated At:</strong>{" "}
                            {viewData.updated_at
                              ? moment(viewData.updated_at).format(
                                  "YYYY-MM-DD HH:mm"
                                )
                              : "-"}
                          </div>
                        </div>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={() => setShowView(false)}
                        style={{
                          background: "#04631e",
                          borderColor: "#04631e",
                        }}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({});
                  }}
                >
                  Add New Exchange Rate
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExchangeRate;
